import axios from "axios";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {IBusinessPolicyOperationStartOptions, IBusinessPolicyOperationStatus, IBusinessPolicyService} from "../PA.MD.Core/PA.MD.IF.BusinessPolicy";


export interface IBusinessPolicyServiceRequest {
    requestType:    string,
    wbPolicyId?:    number,
    options?:       any
}

export interface IBusinessPolicyServiceResponse {
    request: IBusinessPolicyServiceRequest,
    bSuccess: boolean,
    sErrors: string[],
    sWarnings: string[],
    results: any
}

export class BusinessPolicyService
    implements IBusinessPolicyService
{
    constructor() {}

    async getPolicyProcessingStatus(wbPolicyId: number): Promise<IBusinessPolicyOperationStatus> {
        return await BusinessPolicyService.makeRequest({
            requestType: "getPolicyProcessingStatus",
            wbPolicyId: wbPolicyId
        })
    }

    async startPolicyProcessing(wbPolicyId: number, options: IBusinessPolicyOperationStartOptions): Promise<void> {
        return await BusinessPolicyService.makeRequest({
            requestType: "startPolicyProcessing",
            wbPolicyId: wbPolicyId,
            options : options || {}
        })
    }

    //
    private static async makeRequest(hierarchyRequest: IBusinessPolicyServiceRequest)
        : Promise<any>
    {

        try {

            let sEndPoint = <string>(PAEnvironment.getValue(PAEnvironment.Network_URL_Base, "/"));
            if (sEndPoint.endsWith('/'))
                sEndPoint += 'businessPolicy';
            else
                sEndPoint += '/businessPolicy';

            let resp = await axios.post(sEndPoint, {data: {request: hierarchyRequest}})
            let responseData: IBusinessPolicyServiceResponse = resp.data;
            if ('request' in responseData) {
                if (!responseData.bSuccess) {
                    throw new Error("Business Policy Service Response: " + (responseData.sErrors || ['Unknown']).toString())
                } else {
                    return responseData.results
                }
            }

            throw new Error('Unable to parse Business Policy Web Response: ' + responseData);

        } catch (err: any) {
            throw new Error('Unable to obtain Business Policy Results from Server. ' + err);
        }
    }

}
